module.exports = __webpack_public_path__ + "img/cost_icon_11.0427a807.svg";